import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/543'

const RevenueByHandoffTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="revenue.tabs.revenue_by_handoff"
  />
)

export default RevenueByHandoffTab
